<template>
    <v-container fill-height class="py-0">
        <v-row justify="center" align="center">
            <v-col cols="12" xl="4" lg="5" md="6">
                <v-img class="mx-auto ml-md-0" src="/images/neumann-logo.png" width="250"></v-img>
                <p class="mt-6 mb-0 subtitle text-center text-md-left">Aprende un nuevo idioma de una manera fácil, cómoda y divertida.</p>
            </v-col>
            <v-col cols="12" xl="3" lg="4" md="6">
                <v-card>
                    <v-card-text>
                        <v-form ref="register" v-on:submit.prevent="submit">
                            <v-text-field
                                v-model="names"
                                :rules="[rules.required]"
                                placeholder="Nombre(s)"
                                outlined
                            >
                            </v-text-field>
                            <v-text-field
                                v-model="paternal_surname"
                                :rules="[rules.required]"
                                placeholder="Apellido paterno"
                                outlined
                            >
                            </v-text-field>
                            <v-text-field
                                v-model="maternal_surname"
                                :rules="[rules.required]"
                                placeholder="Apellido materno"
                                outlined
                            >
                            </v-text-field>
                            <v-text-field
                                v-model="phone"
                                :rules="[rules.required, rules.phone]"
                                placeholder="Whatsapp"
                                outlined
                            >
                            </v-text-field>
                            <v-text-field
                                type="email"
                                @keydown.space.prevent
                                v-model="email"
                                :rules="[rules.required, rules.email]"
                                color="#008DD4"
                                name="email"
                                outlined
                                placeholder="Correo electrónico"
                            ></v-text-field>
                            <v-text-field
                                :type="show_password ? 'text' : 'password'"
                                :append-icon="show_password ? 'mdi-eye' : 'mdi-eye-off'"
                                v-model="password"
                                :rules="[rules.required]"
                                color="#008DD4"
                                name="password"
                                outlined
                                placeholder="Contraseña"
                                @click:append="show_password = !show_password"
                            ></v-text-field>
                            <v-row class="py-0 my-0" no-gutters>
                                <v-spacer></v-spacer>
                                <v-checkbox color="#008DD4" :rules="[rules.required]" class="my-0">
                                    <template v-slot:label>
                                        <div>
                                            Acepto
                                            <a @click.stop="politics = !politics">
                                                politicas de privacidad
                                            </a>
                                        </div>
                                    </template>
                                </v-checkbox>
                            </v-row>
                            <v-btn type="submit" block color="success" x-large>Registrate</v-btn>
                        </v-form>
                    </v-card-text>
                </v-card>

                <v-card class="mt-3">
                    <v-card-text class="py-0">
                        <v-col class="text-center">
                            <a href="/login" class="text-decoration-none">¿Ya tienes una cuenta?</a>
                        </v-col>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <v-dialog v-model="politics" max-width="800" scrollable>
            <v-card>
                <v-card-title>Politicas de privacidad</v-card-title>
                <v-card-text class="text-justify">
                    La presente Política de Privacidad establece los términos en que Instituto Neumann usa y protege la información que es proporcionada por sus usuarios al momento de utilizar su sitio web. Esta compañía está comprometida con la seguridad de los datos de sus usuarios. Cuando le pedimos llenar los campos de información personal con la cual usted pueda ser identificado, lo hacemos asegurando que sólo se emplea de acuerdo con los términos de este documento. Sin embargo esta Política de Privacidad puede cambiar con el tiempo o ser actualizada por lo que le recomendamos y enfatizamos revisar continuamente esta página para asegurarse que está de acuerdo con dichos cambios.
                    <br>
                    <br>
                    <h4>Información que es recogida</h4>
                    Nuestro sitio web podrá recoger información personal por ejemplo: Nombre,  información de contacto como  su dirección de correo electrónico e información demográfica. Así mismo cuando sea necesario podrá ser requerida información específica para procesar algún pedido o realizar una entrega o facturación.
                    Uso de la información recogida
                    Nuestro sitio web emplea la información con el fin de proporcionar el mejor servicio posible, particularmente para mantener un registro de usuarios, de pedidos en caso que aplique, y mejorar nuestros productos y servicios.  Es posible que sean enviados correos electrónicos periódicamente a través de nuestro sitio con ofertas especiales, nuevos productos y otra información publicitaria que consideremos relevante para usted o que pueda brindar algún beneficio, estos correos electrónicos serán enviados a la dirección que usted proporcione y podrán ser cancelados en cualquier momento.
                    Instituto Neumann está altamente comprometido para cumplir con el compromiso de mantener su información segura. Usamos los sistemas más avanzados y los actualizamos constantemente para asegurarnos que no exista ningún acceso no autorizado.
                    <br>
                    <br>
                    <h4>Cookies</h4>
                    Una cookie se refiere a un fichero que es enviado con la finalidad de solicitar permiso para almacenarse en su ordenador, al aceptar dicho fichero se crea y la cookie sirve entonces para tener información respecto al tráfico web, y también facilita las futuras visitas a una web recurrente. Otra función que tienen las cookies es que con ellas las web pueden reconocerse individualmente y por tanto brindarte el mejor servicio personalizado de su web.
                    Nuestro sitio web emplea las cookies para poder identificar las páginas que son visitadas y su frecuencia. Esta información es empleada únicamente para análisis estadístico y después la información se elimina de forma permanente. Usted puede eliminar las cookies en cualquier momento desde su ordenador. Sin embargo las cookies ayudan a proporcionar un mejor servicio de los sitios web, estas no dan acceso a información de su ordenador ni de usted, a menos de que usted así lo quiera y la proporcione directamente . Usted puede aceptar o negar el uso de cookies, sin embargo la mayoría de navegadores aceptan cookies automáticamente pues sirve para tener un mejor servicio web. También usted puede cambiar la configuración de su ordenador para declinar las cookies. Si se declinan es posible que no pueda utilizar algunos de nuestros servicios.
                    <br>
                    <br>
                    <h4>
                        Enlaces a Terceros
                    </h4>
                    Este sitio web pudiera contener enlaces a otros sitios que pudieran ser de su interés. Una vez que usted dé clic en estos enlaces y abandone nuestra página, ya no tenemos control sobre al sitio al que es redirigido y por lo tanto no somos responsables de los términos o privacidad ni de la protección de sus datos en esos otros sitios terceros. Dichos sitios están sujetos a sus propias políticas de privacidad por lo cual es recomendable que los consulte para confirmar que usted está de acuerdo con estas.
                    <br>
                    <br>
                    <h4>
                        Control de su información personal
                    </h4>
                    En cualquier momento usted puede restringir la recopilación o el uso de la información personal que es proporcionada a nuestro sitio web. Esta compañía no venderá, cederá ni distribuirá la información personal que es recopilada sin su consentimiento, salvo que sea requerido por un juez con un orden judicial.
                    Instituto Neumann Se reserva el derecho de cambiar los términos de la presente Política de Privacidad en cualquier momento.

                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="politics = false">Cerrar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>


    </v-container>
</template>
<script>

import iziToast from 'izitoast'

export default {
    props:['referred', 'is_page', 'course_id'],
    data: () => ({

        //models
        form:false,
        dialog:false,
        politics:false,

        //urls
        img:"/images/option2.png",
        store_url:"/register",

        //props
        color: "#000",
        loading:false,
        email_error_messages:"",
        name_error_messages:"",
        error_message:"",

        //rules
        rules:{
            required: v => !!v || 'El campo es requerido',
            email: v => /^[^@]+@[^@]+\.[a-zA-Z]{2,}$/.test(v) || 'El Correo electrónico ingresado no es válido',
            length: v  => !!v && v.length >= 8 || 'Debe contener al menos 8 caracteres',
            phone: v => !!v && v.length >= 10 || 'Debe contener al menos 10 caracteres',
        },

        //form models
        names:"",
        paternal_surname:"",
        maternal_surname:"",
        email:"",
        name:"",
        password:"",
        password_confirmation:"",
        teacher:false,
        phone:"",
        institute:"",
        proof_institute:[],

        show_password:false
    }),

    watch:{
        password:function(val){
            this.password_confirmation = val
        },
    },

    methods:{
        submit:function(event){
            if(this.$refs.register.validate()){
                this.loading = true

                let data = new FormData();
                data.append('names', this.names)
                data.append('paternal_surname', this.paternal_surname)
                data.append('maternal_surname', this.maternal_surname)
                data.append('email', this.email)
                data.append('name', this.email)
                data.append('password', this.password)
                data.append('password_confirmation', this.password_confirmation)
                data.append('phone', this.phone)
                data.append('teacher', this.teacher ? '1' : '0')
                data.append('referred', JSON.stringify(this.referred))
                data.append('institute', this.institute)
                data.append('proof_institute', this.proof_institute)
                data.append('course_id', this.course_id)

                axios.post(this.store_url, data).then(response => {
                    this.loading = false
                    location.replace(response.data.redirect ? '/home' : '/login')
                }).catch(error => {
                    this.loading = false
                    if(error.response.data.errors){
                        for(let prop in error.response.data.errors){
                            for(let message of error.response.data.errors[prop]){
                                iziToast.error({
                                    title:"Error",
                                    position:'topRight',
                                    message: message
                                })
                            }
                        }
                    }else{
                        iziToast.error({
                            title:"Error",
                            position:'topRight',
                            message: "Ha ocurrido un error en la comunicación con el servidor, intente más tarde"
                        })
                    }
                })
            }
        }
    },

    computed:{

    }
}
</script>
